var map = {
	"./stamp1.png": 6238,
	"./stamp10.png": 28,
	"./stamp2.png": 5013,
	"./stamp3.png": 1148,
	"./stamp4.png": 1107,
	"./stamp5.png": 346,
	"./stamp6.png": 9329,
	"./stamp7.png": 6616,
	"./stamp8.png": 8271,
	"./stamp9.png": 3174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3938;